<template>
	<div class="d-flex flex-1 h-100 overflow-auto">
		<v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
				<div class="custom-icon-wrapper">
					<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
				</div>
				<v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageResources") }}</v-toolbar-title>
			</v-toolbar>

			<div class="border-top p-4 flex-1 overflow-auto">
				<div class="row align-items-start flex-nowrap m-0 gap-2" style="flex: unset">
					<div class="col-md-4 p-0">
						<v-label>{{ $t("res_Label_SearchforResource") }}</v-label>
						<v-text-field v-model="search_query" label="" solo @keydown.enter="triggerSearch"></v-text-field>
					</div>
					<div class="col-md-4 p-0 h-100">
						<div class="d-flex gap-2 h-100 align-items-end">
							<v-btn color="light-blue" dense @click="clearFields()">{{ $t("res_ButtonText_Clear") }}</v-btn>
							<v-btn color="primary" dense @click="Search(true)" ref="searchButton">{{ $t("res_ButtonText_Search") }}</v-btn>
							<v-btn color="primary" @click="Add()">{{ $t("res_ButtonText_Add") }}</v-btn> 
							<v-btn color="primary" @click="upsertUploadResourceFileDialog = true">{{ $t("res_ButtonText_Import") }}</v-btn> 
							<v-btn color="primary" @click="ExportResources()">{{ $t("res_ButtonText_Export") }}
								<v-progress-circular v-show="ShowExportLoader" color="white" class="mt-1 ml-1 mb-1" indeterminate :size="20"></v-progress-circular>
							</v-btn>
						</div>
					</div>
				</div>

				<Pagination
					class="mb-2"
					:totalCount="pagingData.totalCount"
					:pageSize="pagingData.pageSize"
					:pageIndex="pagingData.pageIndex"
					@pageIndexChanged="pageIndexChanged"
				></Pagination>
 
				<div class="d-flex flex-1 flex-column overflow-auto mt-2">
					<v-data-table :mobile-breakpoint="0"
						class="position-relative white flex-1 d-flex overflow-auto ResourcesTable"
						disable-sort
						:headers="headers"
						:items="Resource_items"
						:loading="loading"
						loading-text="loading..."
						:no-data-text="$t('res_Label_NoData')"
						:footer-props="{ 'items-per-page-text': 'Items per page',}"
						caption=""
						hide-default-footer
						header-fixed
						:class="Resource_items.length === 0 ? 'no-data':'ResourceTable'"
						:items-per-page="pagingData.pageSize">
						<template v-slot:no-data>
							<div>
								<img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
								<p class="m-0"> {{ $t("res_No_new_items_here") }} </p>
							</div>
						</template> 
						<template v-slot:item="row">
							<tr>
								<td class="text-center">
									{{ row.item.keyword }}
								</td>
								<td class="text-center">
									<span>{{ row.item.enValue }}</span>
								</td>
								<td class="text-center">
									<span>{{ row.item.arValue }}</span>
								</td>
								<td class="text-center">
									<div class="onhover-display">
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('Update')" @click="GetRecord(row.item.id)">custom-icon white-bg edit-icon</v-icon>
										</div>
										<div class="custom-icon-wrapper">
											<v-icon v-tooltip.hover="$t('res_ButtonText_Delete')" @click="DeleteRecord(row.item.id)">custom-icon white-bg delete-icon</v-icon>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
		</v-card>

		<v-dialog v-model="upsertUploadResourceFileDialog" content-class="Resource-Add-dialog">
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">{{ $t("res_DialogTitle_AddEditUploadResourceFile") }}</v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="upsertUploadResourceFileDialog = false" >
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>  
				<div class="row p-4">
					<div class="col-12">
						<v-label>{{ $t("res_Label_Language") }}</v-label>
						<v-select v-model="selectedLang" :items="LangItems" item-text="text" item-value="val" label="" solo ></v-select>
					</div> 
					<div class="col-12">
						<v-label>{{ $t("res_Label_File") }}*</v-label>
						<v-file-input v-model="selectedFile" :label="$t('res_Label_Choosefile')" @change="handleFileChange" accept=".json" ></v-file-input>
					</div>
				</div> 
				<v-card-actions class="gap-2 sticky-actions" style="">
					<v-spacer></v-spacer> 
					<v-btn class="primary" @click="UploadFile()" style="width: 100px">{{ $t("res_ButtonText_Upload") }}
						<v-progress-circular v-show="ShowUploadLoader" color="white" class="mt-1 ml-1 mb-1" indeterminate :size="20"></v-progress-circular>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="upsertResourceDialog" content-class="Resource-Add-dialog" >
			<v-card>
				<v-toolbar class="bg-white">
					<v-card-title class="p-0">{{ $t("res_DialogTitle_AddEditResource") }}</v-card-title>
					<v-spacer></v-spacer>
					<v-btn class="close-btn light-btn" icon dark @click="upsertResourceDialog = false" >
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar> 
				<div class="d-flex flex-column overflow-auto h-100">
					<div class="grid-1 flex-1 p-3 overflow-auto gap-2">
						<div>
							<v-label>{{ $t("res_Label_Keyword") }}*</v-label>
							<v-text-field maxlength="200" v-model="Resource.keyword" label="" solo ></v-text-field>
						</div>
						<div style="margin-top: 10px">
							<v-label>{{ $t("res_Label_EnValue") }} *</v-label>
							<v-text-field maxlength="500" v-model="Resource.enValue" label="" solo ></v-text-field>
						</div>
						<div style="margin-top: 10px">
							<v-label>{{ $t("res_Label_ArValue") }} *</v-label>
							<v-text-field maxlength="500" v-model="Resource.arValue" label="" solo></v-text-field>
						</div>
					</div> 
					<v-card-actions class="gap-2 sticky-actions" style="">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important" @click="closeupsertResourceDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important" @click="upsert()">
							{{ $t("res_ButtonText_Continue") }}
						</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import axios from "axios";
	import router from "@/router/index.js";
	import constants from "@/assets/js/constants";
	import MultiSelect from "vue-multiselect";
	import ManageApplicationRoles from "@/components/ManageApplicationRoles.vue";
	import Pagination from "@/components/Pagination.vue";
	import StructureUserSelector from "@/components/StructureUserSelector.vue";
	export default {
		name: "ManageResources",
		components: {
			MultiSelect,
			ManageApplicationRoles,
			Pagination,
			StructureUserSelector,
		},
		data: function () {
			return {
				ShowExportLoader: false,
				ShowUploadLoader: false,
				selectedLang: "en",
				LangItems: [
					{ text: this.$t("res_label_English"), val: "en" },
					{ text: this.$t("res_label_Arabic"), val: "ar" },
				],
				selectedFile: null,
				upsertUploadResourceFileDialog: false,
				loading: false,
				search_query: "",
				Resource_items: [],
				company_items: [],
				userId: 0,
				manageApplicationRoleDialog: false,
				options: ["list", "of", "options"],
				headers: [
					{
						text: this.$t("res_GridHeaders_Keyword"),
						value: "keyword",
					},
					{
						text: this.$t("res_GridHeaders_EnValue"),
						value: "creator",
					},
					{
						text: this.$t("res_GridHeaders_ArValue"),
						value: "creator",
					},
					{
						text: "",
						value: "actions",
						sortable: false,
						width: "190px",
					},
				],
				upsertResourceDialogMode: "new",
				upsertResourceDialog: false,
				loginProviders: [
					{ id: "1", name: "Local" },
					{ id: "3", name: "Microsoft" },
				],
				privacies: [],
				contactRoles: [],
				applicationRoles: [],
				Resource: {
					keyword: "",
					enValue: "",
					arValue: "",
				},
				pagingData: {
					pageSize: 10,
					pageIndex: 0,
					totalCount: 0,
				},
			};
		},
		methods: {
			triggerSearch() {
				this.$refs.searchButton.$el.click()
			},
			async ExportResources() {
				this.ShowExportLoader = true;
				await Promise.all([
					this.ExportResourceFile("en"),
					this.ExportResourceFile("ar"),
				]);
				this.ShowExportLoader = false;
			},
			async ExportResourceFile(lang = "en") {
				try {
					const response = await axios.get(
						constants.baseApiUrl + `Resources/Files/${lang}`,
						{
							responseType: "blob",
						}
					);
					const blob = new Blob([response.data], {
						type: response.headers["content-type"],
					});
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.style.display = "none";
					a.href = url;
					a.download = `${lang}.json`;
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					document.body.removeChild(a);
				} catch (error) {
					console.error("File download failed", error);
				}
			},
			handleFileChange(file) {
				if (file.name.endsWith(".json")) {
					this.selectedFile = file;
				} else {
					window.showAlert("Please select a JSON file.");
					this.selectedFile = null;
				}
			},
			async UploadFile() {
				if (!this.selectedFile) {
					return window.showAlert(this.$t("res_Msgs_FillRequired"));
				}
				this.ShowUploadLoader = true;
				const formData = new FormData();
				formData.append("file", this.selectedFile);
				try {
					const response = await axios.post(
						constants.baseApiUrl +
							`Resources/Files/${this.selectedLang}`,
						formData,
						{
							headers: {
								"Content-Type": "multipart/form-data",
							},
						}
					);
					this.ShowUploadLoader = false;
					if (response.data != null && response.data.success) {
						window.showAlert(
							this.$t("res_Msgs_SuccessfullySaved"),
							"success"
						);
						this.upsertUploadResourceFileDialog = false;
						this.selectedLang = "en";
						this.selectedFile = null;
						this.Search();
					} else if (response.data.message != null) {
						window.showAlert(this.$t(response.data.message));
					}
				} catch (error) {
					console.error("File upload failed", error);
				}
			},
			getLoginProviders: function () {
				axios
					.get(constants.baseApiUrl + "Admin/ListLoginProviders")
					.then((res) => (this.loginProviders = res.data))
					.catch((err) => console.warn(err));
			},
			checkArabicEvent(e) {
				const arabicRegex = /^[\u0600-\u06FF\s]+$/;
				if (!arabicRegex.test(e.key)) {
					e.preventDefault();
					window.showAlert(
						this.$t("res_Msgs_NotValidArabicKeyword"),
						"warning"
					);
				}
			},
			Search: function () {
				axios
					.get(
						constants.baseApiUrl +
							`Resources/All?SearchTerm=${this.search_query.trim()}&PageNumber=${
								this.pagingData.pageIndex
							}&PageSize=${this.pagingData.pageSize}`
					)
					.then((res) => {
						if (
							res != null &&
							res != undefined &&
							res.data != "" &&
							res.data != null
						) {
							this.Resource_items = res.data.records;
							this.totalRows = res.data.total;
							this.pagingData.totalCount = res.data.total;
						} else {
							this.Resource_items = [];
							this.totalRows = 0;
							this.pagingData.totalCount = 0;
						}
					})
					.catch((err) => console.warn(err));
			},
			backToAdminPage() {
				router.push({ name: 'manageSystemLookups' });
			},
			clearFields() {
				this.search_query = "";
				this.Search();
			},
			clearInputs() {
				let HTMLeditor = document.getElementById("editor");
				if (HTMLeditor != null) {
					document.getElementById("editor").innerHTML = "";
				}
				this.Resource.keyword = "";
				this.Resource.enValue = "";
				this.Resource.arValue = "";
			},
			Add() {
				this.upsertResourceDialogMode = "new";
				this.upsertResourceDialog = true;
				this.clearInputs();
			},
			GetRecord(id) {
				this.clearInputs();
				axios
					.get(constants.baseApiUrl + `Resources/${id}`)
					.then((res) => {
						this.Resource = res.data;
						this.Resource.arValue = res.data.arValue;
						this.upsertResourceDialogMode = "edit";
						this.upsertResourceDialog = true;
					})
					.catch((err) => console.warn(err));
			},
			DeleteRecord(id) {
				axios
					.delete(constants.baseApiUrl + `Resources/${id}`)
					.then((res) => {
						window.showAlert(
							this.$t("res_Msgs_FilingOrClassificationDeleted"),
							"success"
						);
						this.Search();
					})
					.catch((err) => console.warn(err));
			},
			upsert() {
				var isFormValid = true;
				isFormValid =
					this.Resource.keyword.trim() != "" &&
					this.Resource.enValue.trim() != "" &&
					this.Resource.arValue.trim() != "";

				if (isFormValid == false) {
					window.showAlert(
						this.$t("res_Msgs_FillRequired"),
						"warning"
					);
					return;
				}
				axios
					.post(constants.baseApiUrl + "Resources", this.Resource)
					.then((res) => {
						if (res.data.success == true) {
							window.showAlert(
								this.$t("res_Msgs_SuccessfulSave"),
								"success"
							);
							this.closeupsertResourceDialog();
							this.clearInputs();
							this.clearFields();
							this.Search();
						} else if (
							res.data.success == false &&
							res.data.message.length > 0
						) {
							window.showAlert(this.$t(res.data.message));
						}
					})
					.catch((err) => console.warn(err));
			},
			closeupsertResourceDialog() {
				this.Resource = {
					keyword: "",
					enValue: "",
					arValue: "",
				};
				this.upsertResourceDialogMode = "new";
				this.upsertResourceDialog = false;
			},
			pageIndexChanged(pagingData) {
				this.pagingData.pageSize = pagingData.pageSize;
				this.pagingData.pageIndex = pagingData.pageIndex;
				this.Search();
			},
		},
		mounted: function () {
			this.contactRoles = constants.contactRoles;
			this.privacies = constants.privacies;
			this.getLoginProviders();
			const intervalId = setInterval(() => {
				if (constants.isApplicaitonRolesLoaded == true) {
					clearInterval(intervalId);
					if (constants.isApplicaitonRolesLoaded == true)
						this.applicationRoles = constants.applicationRoles;
				}
			}, 100);

			this.Search();
		},
	};
</script>

<style>
	.Resource-Add-dialog {
		width: 700px;
	}

	.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active {
		/* min-width: auto !important; */
	}

	.ResourceTable thead th span {
		justify-content: center !important;
	}

	.ResourcesTable td span {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		line-height: 22px;
		max-height: 44px;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		white-space: pre-line;
	}
</style>

<style scoped>
	.vtooltip {
		background-color: white;
		padding: 5px;
		border-radius: 25px;
	}
	.report-container .v-input--selection-controls {
		margin-top: 0;
		padding-top: 0;
	}

	.report_header {
		height: 50px;
		vertical-align: middle;
		font-weight: 500;
		font-size: 12px;
		letter-spacing: 0.015em;
		color: #667593;
	}

	.report-container
		.theme--light.v-data-table.v-data-table--fixed-header
		thead
		th,
	.report-container .v-data-table__wrapper table thead {
		background-color: #fff;
		box-shadow: none;
	}

	.report-container {
		height: calc(100vh - 116px);
		display: flex;
		flex-direction: column;
		border-radius: 12px !important;
		overflow: auto;
		box-shadow: none !important;
	}

	.report-container .border-top {
		display: flex;
		flex-direction: column;
	}

	.report-container .v-toolbar {
		height: 80px !important;
		padding: 0;
	}
	.report-container .v-toolbar__content {
		height: 100% !important;
		padding: 24px !important;
	}
	img#ItemPreview {
		width: 100px;
		margin: 0.5rem 0;
	}
	.mdi-menu-down {
		filter: brightness(0) saturate(100%) invert(39%) sepia(56%)
			saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important ;
	}
	.v-dialog .v-toolbar__content {
		height: 100% !important;
	}
</style>
